import { MediaType } from '../media-types';
import { isOctetStream, preferredTypeFromExt, preferredTypeFromType } from '../types-and-exts';
import { isDef } from '../utils/common';
import { getSimpleExt, getUrlExt, getUrlNoQsOrFragment } from '../utils/ext';

const knownUrlExts: ReadonlySet<string> = new Set([
	'.html',
	'.htm',
	'.aspx',
	'.asp',
	'.php',
	'.do',
]);

// Meant to work with AttInfoType or MimeNodeBase
interface Input {
	contentType: string | undefined;
	contentLocation: string | undefined;

	fileName?: string;
	contentTypeName?: string;
	contentDispositionFilename?: string;
}

export function identifyType(att: Input): string | undefined {
	// If the content type is set, and it is not generic, return the preferred version
	if (att.contentType && !isOctetStream(att.contentType)) {
		// Something that is not HTML or CSS
		return preferredTypeFromType(att.contentType) ?? att.contentType;
	}

	// Check filename extention
	const filename = att.fileName || att.contentDispositionFilename || att.contentTypeName;

	{
		const ext = getSimpleExt(filename)?.toLowerCase();

		const type = preferredTypeFromExt(ext);
		if (type) {
			return type;
		}

		if (ext) {
			// Something that is not HTML or CSS
			return;
		}
	}

	{
		// Try again with content location
		const ext = getUrlExt(att.contentLocation)?.toLowerCase();

		const type = preferredTypeFromExt(ext);
		if (type) {
			return type;
		}

		if (ext && knownUrlExts.has(ext)) {
			return MediaType.Html;
		}
	}

	{
		// No ext, but sometimes the URL ends in the extension... like https://hello.com/index/html
		// or https://www.gstatic.com/_/apps-fileview/_/js/k
		const parts = getUrlNoQsOrFragment(att.contentLocation)?.toLowerCase().split('/');

		while (true) {
			const basepath = parts?.pop();
			if (!isDef(basepath)) {
				break;
			}

			const type = preferredTypeFromExt(basepath);
			if (type) {
				return type;
			}

			if (basepath && knownUrlExts.has('.' + basepath)) {
				return MediaType.Html;
			}
		}
	}
}
